import React from 'react';
import PostTime from '../svg/posttime';
import Link from 'next/link';
import { getStrapiURL } from '@/helper/image-helper';


interface BlogItemProps {
    title: string;
    
    image: string;
    link: string;
    minRead: string;
    imageAlt?: string;
}

const BlogItem: React.FC<BlogItemProps> = ({ title, image, link,  minRead, imageAlt}) => {
    
    return (
        <>
            <Link href={link} >
                    <div  className="block w-[calc((100%-1320px)/2)">
                        <div className="w-full h-[240px] rounded-[24px] overflow-hidden">
                            <img className='w-full rounded-[24px] h-full object-cover' src={getStrapiURL(image)} alt={imageAlt} />
                        </div>
                        <p className='mt-[16px] flex items-center gap-[4px] text-[14px] font-medium text-gray-600 leading-[1.5]'>
                            <PostTime />
                            {minRead}
                        </p>
                        <h2 className='mt-[8px] text-[18px] font-bold text-black-50'>{title}</h2>
                    </div>
                </Link>
        </>
    )
}

export default BlogItem